<div class="component-container">
    <div class="bottom-action-mg groups-shops-create-form-container" fxLayoutGap="1rem">
        <custom-panel
            [header]="'Szczegóły cechy'"
            [areButtons]="false"
        >
            <div panel-body *ngIf="!isLoading">
                <div class="features-details-wrapper mt-xxs" fxLayout="column">
                    <div>
                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>ID CECHY: <span class="text-primary pl-xxs">{{ featureId }}</span></p>
                        </div>

                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>NAZWA CECHY: <span class="text-primary pl-xxs">{{ featureName }}</span></p>
                        </div>

                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>RODZAJ CECHY: <span class="text-primary pl-xxs">{{ featureType }}</span></p>
                        </div>
                    </div>

                    <div>
                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>WŁAŚCICIEL CECHY: <span class="text-primary pl-xxs">{{ createdByUserName }}</span></p>
                        </div>

                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>OSTATNIA EDYCJA CECHY: <span class="text-primary pl-xxs">{{ updatedAt }}</span></p>
                        </div>

                        <div class="group references-group mt-xs mb-s" fxFlex="33%">
                            <p>OSTATNI EDYTOR CECHY: <span class="text-primary pl-xxs">{{ updatedByUserName }}</span></p>
                        </div>
                    </div>

                    <div class="select-box mt-0 mb-s" *ngIf="featureType === 'Select'">
                        <p class="sim-step-hint pv-xs" fxLayout="row" fxLayoutAlign="flex-start center">
                            <mat-icon class="text-green">info</mat-icon>
                            <span class="ml-xxs">Opcje które będą widoczne w polu typu Select:</span>
                        </p>
                        <ul *ngFor="let possibleValue of featurePossibleValues">
                            <li><span class="text-primary">{{ possibleValue }}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div panel-body class="text-center pb-s ml-s mt-xs" *ngIf="isLoading">
                <button-spinner [inProgress]="isLoading" diameter="100">
                </button-spinner>
            </div>
        </custom-panel>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row" fxLayoutGap="1%" fxLayoutAlign="flex-end center">
        <button-spinner class="ml-xxs" [inProgress]="isDeleting" diameter="20">
        </button-spinner>
        <button type="button" class="upper action-button butt-back action-button-icon"
                (click)="generalService.goBack()"
        >
            <p class="upper">Wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="openDialog()"
                [disabled]="isDeleting"
                class="upper action-button butt-red action-button-icon"
        >
            <p class="upper">usuń</p>
            <mat-icon class="action-icon">delete</mat-icon>
        </button>
        <button (click)="navToEdit()"
                class="upper action-button butt-primary action-button-icon">
            <p class="upper">edytuj</p>
            <mat-icon class="action-icon">edit</mat-icon>
        </button>
    </div>
</div>
